import CreatableSelect from 'react-select/creatable';
import { Box, Avatar, Text } from '@chakra-ui/react';

const ShareUserSelect = ({ users, value, onChange, assigneeList }) => {
  const userList = assigneeList && assigneeList.length > 0 ? assigneeList : users;
  
  const options = userList.map((user) => ({
    value: user.user_id,
    label: user.username,
    email: user.email,
    avatar: user.avatar,
  }));

  return (
    <CreatableSelect
      isMulti
      isClearable
      placeholder="Names, teams, or emails"
      options={options}
      value={value}
      onChange={onChange}
      formatCreateLabel={(input) => `Invite "${input}"`}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: '44px',
          borderColor: state.isFocused ? '#0052cc' : '#dfe1e6',
          borderWidth: '1px',
          boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 82, 204, 0.1)' : 'none',
          transition: 'all 0.2s ease',
          backgroundColor: '#ffffff',
          cursor: 'text',
          '&:hover': {
            borderColor: '#0052cc',
          },
        }),
        input: (base) => ({
          ...base,
          color: '#262626',
          fontSize: '14px',
        }),
        placeholder: (base) => ({
          ...base,
          color: '#8590a2',
          fontSize: '14px',
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: '#e9f2ff',
          borderRadius: '20px',
          padding: '2px 8px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: '#0052cc',
          fontWeight: 500,
          fontSize: '13px',
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: '#0052cc',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#c2d3ff',
            color: '#002d82',
          },
        }),
        menu: (base) => ({
          ...base,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
          borderRadius: '8px',
          marginTop: '4px',
          overflow: 'hidden',
        }),
        menuList: (base) => ({
          ...base,
          padding: '4px 0',
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? '#0052cc'
            : state.isFocused
            ? '#f0f2f5'
            : 'transparent',
          color: state.isSelected ? '#ffffff' : '#262626',
          cursor: 'pointer',
          padding: '10px 12px',
          transition: 'all 0.15s ease',
          fontSize: '14px',
          '&:active': {
            backgroundColor: state.isSelected ? '#0052cc' : '#e9f2ff',
          },
        }),
        clearIndicator: (base) => ({
          ...base,
          color: '#8590a2',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: '#0052cc',
          },
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: '#8590a2',
          transition: 'all 0.2s ease',
          '&:hover': {
            color: '#0052cc',
          },
        }),
      }}
      components={{
        Option: ({ data, innerRef, innerProps, isFocused, isSelected }) => (
          <Box
            ref={innerRef}
            {...innerProps}
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            px={3}
            py={1}
            mb={0}
            cursor="pointer"
            bg={isSelected ? '#0052cc' : isFocused ? '#f0f2f5' : 'transparent'}
            transition="all 0.15s ease"
            _hover={{
              bg: isSelected ? '#0052cc' : '#f0f2f5',
            }}
          >
            <Avatar
              size="sm"
              name={data.label}
              src={data.avatar}
              mr={3}
              border={isSelected ? '2px solid #0052cc' : 'none'}
            />
            <Box flex="1">
              <Text
                fontSize="sm"
                fontWeight={500}
                mb={0}
                color={isSelected ? '#ffffff' : '#262626'}
              >
                {data.label}
              </Text>
              <Text
                fontSize="xs"
                color={isSelected ? 'rgba(255, 255, 255, 0.7)' : 'gray.500'}
              >
                {data.email}
              </Text>
            </Box>
          </Box>
        ),
        MultiValueLabel: ({ data }) => (
          <Box display="flex" alignItems="center" gap={1.5}>
            <Avatar size="xs" name={data.label} src={data.avatar} />
            <Text fontSize="sm" py={2} fontWeight={500} mb={0} color="#0052cc">
              {data.label}
            </Text>
          </Box>
        ),
      }}
    />
  );
};

export default ShareUserSelect;